var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsBriefcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.899 3.333a4 4 0 0 1 3.993 3.765l.007.235-.001 1.333h2.435a4 4 0 0 1 3.995 3.801l.005.2v12a4 4 0 0 1-4 4H6.667a4 4 0 0 1-4-4v-12a4 4 0 0 1 4-4H9.1V7.332a4 4 0 0 1 3.765-3.993l.235-.007H18.9zm7.767 11.811-6.4 4.223a3.998 3.998 0 0 1-1.91.652l-.293.01h-4.126a3.999 3.999 0 0 1-1.953-.51l-.25-.151-6.401-4.224v9.523c0 .693.529 1.262 1.205 1.327l.129.006h18.666c.737 0 1.334-.596 1.334-1.333l-.001-9.523zm-16.25-3.812-3.75.001c-.513 0-.958.29-1.181.715l7.718 5.094c.174.115.372.187.578.212l.156.009h4.126c.209 0 .414-.05.6-.143l.135-.078 7.717-5.094a1.332 1.332 0 0 0-1.182-.715H10.415zM18.899 6H13.1c-.684 0-1.247.514-1.324 1.178l-.009.155v1.333h8.464V7.333c0-.684-.514-1.247-1.178-1.324L18.9 6z",
    fill: "#727DF9",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsBriefcase);
export default __webpack_public_path__ + "static/media/icons-briefcase.2dfbe5d0d910f0a022e1d53b716343f6.svg";
export { ForwardRef as ReactComponent };